import { useMappings } from 'modules/queryBuilder/hooks/queries';
import { ClientDataType, FieldType } from 'modules/queryBuilder/types';

export const useGetUserFieldType = (isEnabled?: boolean) => {
  const { mappings, isLoading } = useMappings({ dataType: ClientDataType.User, isEnabled });
  const getFieldTypeFromField = (field: string) => {
    return mappings?.find(({ name }) => name === field)?.fieldType ?? FieldType.UNDEFINED;
  };
  return { getFieldTypeFromField, isLoading };
};
